import apiClient from '@/services/axios'

export const getOrganizations = async name => {
  const res = await apiClient.get(`/admin/organizations`, { params: { name } })
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const getOrganizationsById = async id => {
  const res = await apiClient.get(`/admin/organizations/${id}`)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const postOrganizations = async payload => {
  const res = await apiClient.post('/admin/organizations', payload)
  if (res) {
    return res.data
  } else {
    return []
  }
}
export const putOrganizations = async (payload, id) => {
  const res = await apiClient.put(`/admin/organizations/${id}`, payload)
  if (res) {
    return res.data
  } else {
    return []
  }
}

export const deleteOrganization = async id => {
  const res = await apiClient.delete(`/admin/organizations/${id}`)
  if (res) {
    return res.data
  } else {
    return []
  }
}
